import type { XmlComponent } from 'docx';
import { StyleLevel, TableOfContents } from 'docx';
import { Node } from 'slate';

import { createDocxAlineContentBlock } from './general';
import type { DocumentContext } from './internal';
import { isAlineContentBlock } from '../../../slate-api';
import type { TOCElement } from '../../../slate-api';

export function createToc(toc: TOCElement, options: { context: DocumentContext }): TableOfContents {
  const children = Node.children(toc, []);
  const contentChildren: XmlComponent[] = [];

  for (const [child, childPath] of children) {
    if (isAlineContentBlock(child)) {
      const childDocx = createDocxAlineContentBlock([child, childPath], {
        context: options.context,
      });
      const newChildren = Array.isArray(childDocx) ? childDocx : [childDocx];
      contentChildren.push(...newChildren);
    }
  }

  const tocDocx = new TableOfContents('', {
    ...toc.options,
    beginDirty: false,
    contentChildren,
    stylesWithLevels: toc.options.stylesWithLevels?.map(
      ([style, level]) => new StyleLevel(style, level)
    ),
  });

  return tocDocx;
}
